import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUsuarioActual } from "../services/authServicios";
import { puedeAccederRuta } from "../services/rolAutorizacion";
import LoadingScreen from "./organisms/LoadingScreen";

function AuthGuard() {
  const { data: usuario, isLoading, isError } = useUsuarioActual();
  const location = useLocation();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isError || !usuario) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!puedeAccederRuta(usuario, location.pathname)) {
    return <Navigate to="/no-autorizada" replace />;
  }

  return <Outlet />;
}

export default AuthGuard;
